import React from 'react';
import { FileActionDropdown, FolderActionDropdown } from 'shared-portal-components-v2';

import type { FileEntry } from '@/types/SixDetail.types';

interface SixDetailFileBrowserRowActionsProps {
  item: FileEntry;
  canShowRowActions: (item: FileEntry) => boolean;
  onItemAction: (item: FileEntry, action: string) => void;
}

function SixDetailFileBrowserRowActions({
  item,
  canShowRowActions,
  onItemAction,
}: SixDetailFileBrowserRowActionsProps): React.ReactElement {
  if (item.isNavigationEntry === true || !canShowRowActions(item)) {
    return <></>;
  }

  if (item.kind === 'folder') {
    return (
      <FolderActionDropdown
        onOpen={() => {
          onItemAction(item, 'open');
        }}
        onDelete={() => {
          onItemAction(item, 'delete');
        }}
      />
    );
  }

  return (
    <FileActionDropdown
      onDelete={() => {
        onItemAction(item, 'delete');
      }}
    />
  );
}

export default SixDetailFileBrowserRowActions;
